import dayjs from 'dayjs';
import { useMemo } from 'react';
import { hoursType } from '../../../features/workflow/types';

export const formatToTime = (str: string | undefined | null, backupMessage?: string) => {
  let date = dayjs(str);
  if (!date.isValid()) {
    date = dayjs(str + 'Z');
  }
  if (!date.isValid() || str == undefined) {
    return backupMessage ?? 'Not Set';
  }
  return date.format('h:mm A');
};
export const useHoursFormat = (hours: hoursType | undefined | null) => {
  const start = useMemo(() => formatToTime(hours?.Start), [hours?.Start]);
  const end = useMemo(() => formatToTime(hours?.End), [hours?.End]);
  return { start, end };
};
